import { useContext } from 'react'
import { ViewerContext } from './context'

export function useViewer() {
  const ctx = useContext(ViewerContext)
  return ctx.viewer ?? undefined
}
